import * as _ from 'lodash'
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {SalesOrgBO} from "./SalesOrgBO";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {
    WB_CustomerCalendarRow,
    WB_CustomerExternalRelationshipRow, WB_LiftAPIRow, WB_Published_ModelRow, WB_TagSourceRow
} from "../PA.Core/PAdbSchemaRows";
import {esWB_Published_Model, esWB_Tag_Source} from "../PA.Core/PAdbSchema";

export class SalesOrgBOValidation {

    static Validate(aBO: SalesOrgBO): Promise<void> {
        return new Promise<void>((resolve, error) => {
            SalesOrgBOValidation.ValidateFields(aBO)
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }
                    return SalesOrgBOValidation.ValidateLiftSettings(aBO)
                })
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }

                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    static async ValidateFields(aBO: SalesOrgBO): Promise<void> {

        const self = this;
        if (!aBO.WB_SalesOrg.isActive)
            return

        if (aBO.bMapping) {


            let messageCust = ""
            let externalRows: any = _.uniqWith(_.orderBy(_.map(_.filter(aBO.WB_SalesOrg.WB_CustomerExternalRelationshipRows, aRow => aRow.isActive), aRow => {
                    return {
                        'WB_CUST_ID_SOURCE': aRow.cif.WB_CUST_ID_SOURCE,
                        'WB_CUST_ID_PLANNING': aRow.cif.WB_CUST_ID_PLANNING,
                        'WB_SALESAREA_ID': aRow.cif.WB_SALESAREA_ID
                    }
                })
                , ['WB_CUST_ID_SOURCE', 'WB_CUST_ID_PLANNING', 'WB_SALESAREA_ID']), _.isEqual)

            _.forEach(externalRows, (aXref: any) => {
                let rows = _.filter(aBO.WB_SalesOrg.WB_CustomerExternalRelationshipRows, aRow => aRow.isActive && aXref.WB_CUST_ID_SOURCE == aRow.cif.WB_CUST_ID_SOURCE && aXref.WB_CUST_ID_PLANNING == aRow.cif.WB_CUST_ID_PLANNING && aXref.WB_SALESAREA_ID == aRow.cif.WB_SALESAREA_ID)
                if (rows.length == 1)
                    return

                while (rows.length > 1) {
                    let rowToCompare = rows[0]
                    rows = _.drop(rows)

                    let overlapRows = _.filter(rows, (aRow: WB_CustomerExternalRelationshipRow) => {
                        return DateUtils.RangeDatesOverlap(DateUtils.convertFromSAPBW(rowToCompare.cif.EFFECTIVE_START_DT), DateUtils.convertFromSAPBW(rowToCompare.cif.EFFECTIVE_END_DT),
                            DateUtils.convertFromSAPBW(aRow.cif.EFFECTIVE_START_DT),
                            DateUtils.convertFromSAPBW(aRow.cif.EFFECTIVE_END_DT));
                    })

                    if (overlapRows.length) {
                        if (!messageCust.length)
                            messageCust = "Planning Customer / Consumption Customer / Sales Area \n"
                        let rowSalesArea = _.first(_.filter(aBO.WB_SalesOrg.WB_SalesAreaRows, aRow => aRow.isActive && aRow.cif.WB_SALESAREA_ID == rowToCompare.cif.WB_SALESAREA_ID))
                        let combo = rowToCompare.WB_CustomerRow_Planning.cif.CUSTOMER_NAME + '(' + rowToCompare.WB_CustomerRow_Planning.cif.CUSTOMER_ID + ')/' + rowToCompare.WB_CustomerRow_Source.cif.CUSTOMER_NAME + '(' + rowToCompare.WB_CustomerRow_Source.cif.CUSTOMER_ID + ') in Sales Ares ' + rowSalesArea.cif.SALESAREA_NAME + '(' + rowSalesArea.cif.SALESAREA_ID + ') \n'
                        if (!messageCust.includes(combo))
                            messageCust += combo

                    }
                }
            })

            if (messageCust) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'overlapCust',
                        type: MessageType.Error,
                        title: "Effective Dates Overlapping",
                        description: "Effective dates cannot overlap for the same planning customer/consumption customer in the same sales area in customer mapping\n" + messageCust,
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('overlapCust')
            }

            if (_.filter(aBO.WB_SalesOrg.WB_CustomerExternalRelationshipRows, aRow => aRow.isActive && aRow.cif.EFFECTIVE_START_DT > aRow.cif.EFFECTIVE_END_DT).length) {

                let badDates = _.filter(aBO.WB_SalesOrg.WB_CustomerExternalRelationshipRows, aRow => aRow.isActive && aRow.cif.EFFECTIVE_START_DT > aRow.cif.EFFECTIVE_END_DT)
                let message: any = _.uniq(_.map(badDates, aRow => {
                    let rowSalesArea = _.first(_.filter(aBO.WB_SalesOrg.WB_SalesAreaRows, anArea => anArea.isActive && anArea.cif.WB_SALESAREA_ID == aRow.cif.WB_SALESAREA_ID))
                    return aRow.WB_CustomerRow_Planning.cif.CUSTOMER_NAME + '(' + aRow.WB_CustomerRow_Planning.cif.CUSTOMER_ID + ')/' + aRow.WB_CustomerRow_Source.cif.CUSTOMER_NAME + '(' + aRow.WB_CustomerRow_Source.cif.CUSTOMER_ID + ')/' + rowSalesArea.cif.SALESAREA_NAME + '(' + rowSalesArea.cif.SALESAREA_ID + ')'
                }))
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'StartDateGtEndDate',
                        type: MessageType.Error,
                        title: "Effective Start Date Greater than Effective End Date",
                        description: "Effective start date cannot be greater than effective end date for the same planning customer/consumption customer in the same sales area in customer mapping\n" + _.join(message, '\n'),
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('StartDateGtEndDate')
            }

            if (_.filter(aBO.WB_SalesOrg.WB_CustomerExternalRelationshipRows, aRow => aRow.isActive && (_.isEmpty(aRow.cif.EFFECTIVE_START_DT) || _.isEmpty(aRow.cif.EFFECTIVE_END_DT))).length) {

                let badDates = _.filter(aBO.WB_SalesOrg.WB_CustomerExternalRelationshipRows, aRow => aRow.isActive && (_.isEmpty(aRow.cif.EFFECTIVE_START_DT) || _.isEmpty(aRow.cif.EFFECTIVE_END_DT)))
                let message: any = _.uniq(_.map(badDates, aRow => {
                    let rowSalesArea = _.first(_.filter(aBO.WB_SalesOrg.WB_SalesAreaRows, anArea => anArea.isActive && anArea.cif.WB_SALESAREA_ID == aRow.cif.WB_SALESAREA_ID))
                    return aRow.WB_CustomerRow_Planning.cif.CUSTOMER_NAME + '(' + aRow.WB_CustomerRow_Planning.cif.CUSTOMER_ID + ')/' + aRow.WB_CustomerRow_Source.cif.CUSTOMER_NAME + '(' + aRow.WB_CustomerRow_Source.cif.CUSTOMER_ID + ')/' + rowSalesArea.cif.SALESAREA_NAME + '(' + rowSalesArea.cif.SALESAREA_ID + ')'
                }))
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyDates',
                        type: MessageType.Error,
                        title: "Effective Start/End Date Empty",
                        description: "Effective start/end date(s) cannot be empty for the planning customer/consumption customer in the sales area in customer mapping\n" + _.join(message, '\n'),
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyDates')
            }

            if (_.filter(aBO.WB_SalesOrg.WB_CustomerExternalRelationshipRows, aRow => aRow.isActive && !(aRow.cif.COVERAGE_FACTOR >= 0 && aRow.cif.COVERAGE_FACTOR <= 2)).length) {

                let badDates = _.filter(aBO.WB_SalesOrg.WB_CustomerExternalRelationshipRows, aRow => aRow.isActive && !(aRow.cif.COVERAGE_FACTOR >= 0 && aRow.cif.COVERAGE_FACTOR <= 2))
                let message: any = _.uniq(_.map(badDates, aRow => {
                    let rowSalesArea = _.first(_.filter(aBO.WB_SalesOrg.WB_SalesAreaRows, anArea => anArea.isActive && anArea.cif.WB_SALESAREA_ID == aRow.cif.WB_SALESAREA_ID))
                    return aRow.WB_CustomerRow_Planning.cif.CUSTOMER_NAME + '(' + aRow.WB_CustomerRow_Planning.cif.CUSTOMER_ID + ')/' + aRow.WB_CustomerRow_Source.cif.CUSTOMER_NAME + '(' + aRow.WB_CustomerRow_Source.cif.CUSTOMER_ID + ')/' + rowSalesArea.cif.SALESAREA_NAME + '(' + rowSalesArea.cif.SALESAREA_ID + ')'
                }))
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'Coverage',
                        type: MessageType.Error,
                        title: "Coverage Range Out of Limit",
                        description: "Coverage Range is not within 0-200 for the planning customer/consumption customer in the sales area in customer mapping\n" + _.join(message, '\n'),
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('Coverage')
            }

        } else {
            let externalRows = _.uniq(_.orderBy(_.map(_.filter(aBO.WB_SalesOrg.WB_CustomerCalendarRows, aRow => aRow.isActive), 'WB_CUST_ID'), 'WB_CUST_ID'))
            let messageCal = ""
            _.forEach(externalRows, (aXref: any) => {
                let rows = _.filter(aBO.WB_SalesOrg.WB_CustomerCalendarRows, aRow => aRow.isActive && aXref == aRow.cif.WB_CUST_ID)
                if (rows.length == 1)
                    return

                while (rows.length > 1) {
                    let rowToCompare = rows[0]
                    rows = _.drop(rows)

                    let overlapRows = _.filter(rows, (aRow: WB_CustomerCalendarRow) => {
                        return DateUtils.RangeDatesOverlap(DateUtils.convertFromSAPBW(rowToCompare.cif.EFFECTIVE_START_DT), DateUtils.convertFromSAPBW(rowToCompare.cif.EFFECTIVE_END_DT),
                            DateUtils.convertFromSAPBW(aRow.cif.EFFECTIVE_START_DT),
                            DateUtils.convertFromSAPBW(aRow.cif.EFFECTIVE_END_DT));
                    })

                    if (overlapRows.length) {
                        if (messageCal.length)
                            messageCal += 'Calendar Settings: \n'
                        let combo = rowToCompare.WB_CustomerRow.cif.CUSTOMER_NAME + '(' + rowToCompare.WB_CustomerRow.cif.CUSTOMER_ID + ') \n'
                        if (!messageCal.includes(combo))
                            messageCal += combo
                    }
                }
            })
            if (messageCal) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'overlapCust',
                        type: MessageType.Error,
                        title: "Effective Dates Overlapping",
                        description: "Effective dates cannot overlap for the same planning customer in calendar settings\n" + messageCal,
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('overlapCal')
            }

            if (_.filter(aBO.WB_SalesOrg.WB_CustomerCalendarRows, aRow => aRow.isActive && aRow.cif.EFFECTIVE_START_DT > aRow.cif.EFFECTIVE_END_DT).length) {

                let badDates = _.filter(aBO.WB_SalesOrg.WB_CustomerCalendarRows, aRow => aRow.isActive && aRow.cif.EFFECTIVE_START_DT > aRow.cif.EFFECTIVE_END_DT)
                let message: any = _.uniq(_.map(badDates, aRow => {
                    return aRow.WB_CustomerRow.cif.CUSTOMER_NAME + '(' + aRow.WB_CustomerRow.cif.CUSTOMER_ID + ')'
                }))
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'StartDateGtEndDate',
                        type: MessageType.Error,
                        title: "Effective Start Date Greater than Effective End Date",
                        description: "Effective start date cannot be greater than effective end date for planning customer(s)\n" + _.join(message, '\n'),
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('StartDateGtEndDate')
            }

            if (_.filter(aBO.WB_SalesOrg.WB_CustomerCalendarRows, aRow => aRow.isActive && (_.isEmpty(aRow.cif.EFFECTIVE_START_DT) || _.isEmpty(aRow.cif.EFFECTIVE_END_DT))).length) {

                let badDates = _.filter(aBO.WB_SalesOrg.WB_CustomerCalendarRows, aRow => aRow.isActive && (_.isEmpty(aRow.cif.EFFECTIVE_START_DT) || _.isEmpty(aRow.cif.EFFECTIVE_END_DT)))
                let message: any = _.uniq(_.map(badDates, aRow => {
                    return aRow.WB_CustomerRow.cif.CUSTOMER_NAME + '(' + aRow.WB_CustomerRow.cif.CUSTOMER_ID + ')'
                }))
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyDates',
                        type: MessageType.Error,
                        title: "Effective Start/ End Date Empty",
                        description: "Effective start/end date(s) cannot be empty for planning customer(s)\n" + _.join(message, '\n'),
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyDates')
            }

            if (_.filter(aBO.WB_SalesOrg.WB_CustomerCalendarRows, aRow => aRow.isActive && aRow.cif.WB_SOURCE_ID == 0).length) {

                let badDates = _.filter(aBO.WB_SalesOrg.WB_CustomerCalendarRows, aRow => aRow.isActive && aRow.cif.WB_SOURCE_ID == 0)
                let message: any = _.uniq(_.map(badDates, aRow => {
                    return aRow.WB_CustomerRow.cif.CUSTOMER_NAME + '(' + aRow.WB_CustomerRow.cif.CUSTOMER_ID + ')'
                }))
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'NoSource',
                        type: MessageType.Error,
                        title: "Source Is Empty",
                        description: "Source cannot be empty for planning customer(s)\n" + _.join(message, '\n'),
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('NoSource')
            }
        }
    }

    static async ValidateLiftSettings(aBO: SalesOrgBO): Promise<void> {

        let activeLiftAPIRows: WB_LiftAPIRow[] = _.filter(aBO.WB_SalesOrg.WB_LiftAPIRows, aRow => aRow.isActive )
        let missingPublishedModelId = _.filter(activeLiftAPIRows, aRow => aRow.cif.WB_PUBLISHED_MODEL_ID <= 0)
        let missingExternalId = _.filter(activeLiftAPIRows, aRow => aRow.cif.EXTERNAL_ID == '')
        let emptyRows = _.filter(activeLiftAPIRows, aRow => aRow.cif.EXTERNAL_ID == '' && aRow.cif.WB_PUBLISHED_MODEL_ID <= 0 && aRow.cif.CALLER_ID == '')

        if(emptyRows.length > 0) {
            // Log Message
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'EmptyRows',
                    type: MessageType.Error,
                    title: "Please delete the empty rows before saving",
                    description: "There are rows with empty Caller ID, External ID and Published Model ID. Please delete those before saving.",
                    count: 0
                })
        }
        else{
            aBO.ValidateMessageProvider.removeMessage('EmptyRows')
            if(missingPublishedModelId.length > 0) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'MissingPublishedModel',
                        type: MessageType.Error,
                        title: "Published Model not selected.",
                        description: "Published Model cannot be empty",
                        count: 0
                    })
            }
            else{
                aBO.ValidateMessageProvider.removeMessage('MissingPublishedModel')
            }

            if(missingExternalId.length > 0) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'MissingExternalID',
                        type: MessageType.Error,
                        title: "External ID cannot be empty",
                        description: "External ID cannot be empty",
                        count: 0
                    })
            }
            else{
                aBO.ValidateMessageProvider.removeMessage('MissingExternalID')
            }
        }

        let rowsByPublishedModelId: {[id:number]: WB_LiftAPIRow[]} = {}
        _.forEach(activeLiftAPIRows, (aRow: WB_LiftAPIRow) => {
            let publishedModelId = aRow.cif.WB_PUBLISHED_MODEL_ID
            if(publishedModelId in rowsByPublishedModelId)
                rowsByPublishedModelId[publishedModelId].push(aRow)
            else
                rowsByPublishedModelId[publishedModelId] = [aRow]
        })

        let modelIds = ""
        for(let key in rowsByPublishedModelId) {
            let existingCombo: string[] = []
            let modelRow: WB_Published_ModelRow = await aBO.dbContext.find(esWB_Published_Model, key)
            _.forEach(rowsByPublishedModelId[key], (anItem) => {
                let callerID = (anItem.cif.CALLER_ID == "") ? "empty" : _.toLower(anItem.cif.CALLER_ID)
                let externalID = _.toLower(anItem.cif.EXTERNAL_ID)
                let concID = callerID + ":" + externalID

                if(existingCombo.indexOf(concID) == -1)
                    existingCombo.push(concID)
                else {
                    modelIds = modelIds + modelRow.cif.PUBLISHED_MODEL_ID.toString() + ", "
                }
            })
        }
        if(modelIds != "") {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'DuplicateError',
                    type: MessageType.Error,
                    title: "The following published model IDs do not have a unique combination of Caller ID and External ID: " + modelIds,
                    description: "The following published model IDs do not have a unique combination of Caller ID and External ID: " + modelIds,
                    count: 0
                })
        }
        else {
            aBO.ValidateMessageProvider.removeMessage('DuplicateError')
        }
    }

    private static addMessage(aBO: SalesOrgBO, code: string, message: string): void {
        aBO.ValidateMessageProvider.addMessage(
            {
                code: code,
                type: MessageType.Error,
                title: message,
                description: "",
                subtitle: "",
                count: 0
            });
    }
}